import React, {useCallback} from "react"
import {userGuideSelectors, userGuideSlice} from "../../slices/userGuideSlice"
import {GreetingsModal} from "./GreetingsModalLazy"
import {getGreetingsModalContent} from "./getGreetingsModalContent"
import {DispatchAction, UseSelector} from "../../lib/reactRedux"
import {Portal} from "../../types/securityTypes"

export interface WrappedGreetingsModalProps {
    dispatch: DispatchAction
    useSelector: UseSelector
    portal: Portal
    appPaths: string[]
    history: any
}

export const WrappedGreetingsModal: React.FC<WrappedGreetingsModalProps> = ({
    portal,
    useSelector,
    dispatch,
    appPaths,
    history,
}) => {
    const onClose = useCallback(() => {
        dispatch?.(userGuideSlice.actions.closeGreetingModal())
    }, [dispatch])

    const greetingsModalOpen = useSelector(userGuideSelectors.getGreetingsModalOpen)
    const template = getGreetingsModalContent(portal)

    return (
        <GreetingsModal
            useSelector={useSelector}
            appPaths={appPaths}
            history={history}
            open={greetingsModalOpen}
            onClose={onClose}
            template={template}
        />
    )
}
